import { request } from './axios.js'
export let addIcaurCusApi = (data) =>
  request({ data, url: '/webapp/api/icaurCus/add', })